<template>
    <div class="c-switch-tabs">
        <button
            type="button"
            class="c-btn"
            :class="{'is-active': activeAddressesTab == 'courier'}"
            @click="setActiveTab('courier')"
        >
            {{ $t('Switch.Addresses.tabCourier') }}
        </button>

        <button
            type="button"
            class="c-btn"
            :class="{'is-active': activeAddressesTab == 'pickup'}"
            @click="setActiveTab('pickup')"
        >
            {{ $t('Switch.Addresses.tabPickup') }}
        </button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    methods: {
        setActiveTab(tab) {
            this.$store.commit('SET_ACTIVE_ADDRESSES_TAB', tab)
        },
    },
    computed: {
        ...mapState([
            'activeAddressesTab',
            'selectedAddressId',
            'pickupAddresses',
        ]),
        ...mapGetters([
            'allAddresses',
        ]),
    },
}
</script>